import type { StepperIndicatorVariant } from './stepperIndicatorTypes'

export const boldTitles: StepperIndicatorVariant[] = ['active', 'error']

const STEP = 'vui-stepperStep'

export const CLASS = {
  step: STEP,
  tail: `${STEP}Tail`,
  tailLeft: `${STEP}TailLeft`,
  tailRight: `${STEP}TailRight`,
  tailLeftIcon: `${STEP}TailLeftIcon`,
  tailRightIcon: `${STEP}TailRightIcon`,
  title: `${STEP}Title`,
} as const

export const CSS_VARS = {
  // Layout (raw CSS values — work as var() fallbacks)
  vertGap: '--vui-stepper-vert-gap',
  horizTailHeight: '--vui-stepper-horiz-tail-height',
  vertTailMaxWidth: '--vui-stepper-vert-tail-max-width',
  // Colors (xstyled tokens — set after th.color() resolution)
  tailColor: '--vui-stepper-tail-color',
  iconTailColor: '--vui-stepper-icon-tail-color',
  titleColor: '--vui-stepper-title-color',
  descColor: '--vui-stepper-desc-color',
  // Indicator circle / icon colors
  indicatorBg: '--vui-stepper-indicator-bg',
  indicatorBorder: '--vui-stepper-indicator-border',
  indicatorColor: '--vui-stepper-indicator-color',
  // Indicator ring (CSS class only — xstyled breaks if used as prop value)
  indicatorOutline: '--vui-stepper-indicator-outline',
} as const
